import React from 'react';
import FeatherIcon from "feather-icons-react";

import Table from "../../../Components/UI/Table/Table";

interface Props {
    campaignList: any,
    showTagHandler:any,
    editTagHandler:any
    showDeleteModal:any
}

const ListingComponent = ({ campaignList,showTagHandler,editTagHandler,showDeleteModal }: Props)=>{
    let columns = [
        {
            Header: "DSP",
            accessor: "dsp",
        },
        {
            Header: "Exc.",
            accessor: "exchange",
        },
        {
            Header: "Type",
            accessor: "type",
        },
        {
            Header:"Add-Ons",
            accessor: "addOns"
        },
        /*{
            Header: "Environment",
            accessor: "env",
            sort: false,
        },*/
        {
            Header: "Youtube Video",
            accessor: "YouTubeVideo",
        },
        {
            Header: "Campaign Name",
            accessor: "name",
        },
        {
            Header: "Landing Page",
            accessor: "landingPage",
        },
        {
            Header: "URL",
            accessor: "",
            Cell: ({ row }: any) =>
            `${
                row.original.type === "Image"
                ? row.original.imageUrl
                : row.original.videoUrl
            }`,
        },
        {
            Header: "Special",
            accessor: "",
            Cell: ({ row }: any) => `${row.original.special ? "Yes" : "No"}`,
        },
        {
            Header: "Actions",
            accessor: "",
            Cell: ({ row }: any) => (
            <p style={{ display: "flex", alignItems: "center", gap:"5px" }}>
                <span 
                title="tag"
                onClick={() => {
                    showTagHandler(row.original.name);
                }}
                >
                <FeatherIcon icon="tag" className="icon-dual" />
                </span>
                <span
                title="edit"
                onClick={() => {
                    editTagHandler(row.original.name);
                }}
                >
                <FeatherIcon icon="edit" className="icon-dual" />
                </span>
                <span
                title="trash"
                onClick={() => {
                    showDeleteModal(row.original);
                }}
                >
                <FeatherIcon  icon="trash-2" className="icon-dual" />
                </span>
            </p>
            ),
        },
    ];
    const sizePerPageList = [
        {
          text: "5",
          value: 5,
        },
        {
          text: "10",
          value: 10,
        },
        {
          text: "20",
          value: 20,
        },
        {
          text: "50",
          value: 50,
        },
    ];
    return (
      <>
        <Table
          columns={columns}
          data={campaignList}
          pageSize={10}
          sizePerPageList={sizePerPageList}
          isSortable={false}
          pagination={true}
          isSearchable={true}
        />
      </>
    );
}

export default ListingComponent;